<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';

export default Vue.extend({
    data() {
        return {
            toggled: false,
        }
    },
    computed: {
        ...mapState({
            form: state => state.contract.contract.form.item,
            contract: state => state.contract.contract.item,
            part: state => state.contract.contract.part
        })
    },
    methods: {
        ...mapActions({
            contractNotesSet: 'contract/contractNotesSet'
        })
    }
});
</script>
<template>
    <div class="contract-form-notes">
        <div class="contract-form-notes__content">
            <div class="contract-form-notes__body">
                <div class="contract-form-notes__toggle" @click="toggled = !toggled">
                    <div class="contract-form-notes__toggle-icon">
                        <span v-if="toggled"><i class="fas fa-chevron-down"/></span>
                        <span v-if="!toggled"><i class="fas fa-chevron-up"/></span>
                    </div>
                    <div class="contract-form-notes__toggle-label">
                        <span v-if="form[part].note"><i class="fa fa-exclamation-circle"/></span>
                        <span>{{ $t('contract.form.notes.toggle') }}</span>
                    </div>
                </div>
                <div v-if="toggled" class="contract-form-notes__input">
                    <textarea :value="form[part].note"
                              :placeholder="$t('contract.form.notes.placeholder')"
                              name="notes"
                              cols="30"
                              rows="10"
                              class="contract-form-notes__input-text"
                              @input="contractNotesSet($event.target.value)"/>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormNotes/ContractFormNotes.vue